import React from 'react';

const Footer = () => {
  return (
    <footer>
      <div className="footer-brand">ValueARC <span>/ The Complete M&A Operating System</span></div>
      <ul className="footer-links">
        <li><a href="#modules">Platform</a></li>
        <li><a href="#launch">Launch</a></li>
        <li><a href="#enroll">Enroll</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="mailto:sunilnikhar@digilantsolution.com">Contact</a></li>
        <li><a href="https://www.linkedin.com/in/sunilnikhar/" target="_blank" rel="noopener noreferrer">LinkedIn</a></li>
      </ul>
      <p className="footer-copy">© 2025 Digilant Solutions Pvt. Ltd. · ValueARC Platform</p>
    </footer>
  );
};

export default Footer;
